<div class="modal__content">
    <div class="select">
        <select class="input" name="selectedObject" id="selectedObject" [(ngModel)]="options.item.signedObject">
            <option *ngFor="let object of objects" [ngValue]="object">{{object.name}}</option>
        </select>
    </div>
</div>
<modal-actions [options]="options" [type]="type"></modal-actions>